import {ValueObject} from '@s-ui/domain'

export const ASSISTANT_CHAT_PAGE_TYPE = {
  HOME: 'HOME',
  AD_LISTING: 'AD_LISTING',
  AD_DETAIL: 'AD_DETAIL'
}

export class AssistantChatPageTypeValueObject extends ValueObject {
  #type

  constructor({type}) {
    super()

    if (!type) throw new Error('type is required')
    if (!Object.values(ASSISTANT_CHAT_PAGE_TYPE).includes(type)) {
      throw new Error(`type must be one of: ${Object.values(ASSISTANT_CHAT_PAGE_TYPE).join(', ')}`)
    }

    this.#type = type
  }

  static create({type} = {}) {
    return new AssistantChatPageTypeValueObject({type})
  }

  get type() {
    return this.#type
  }

  toJSON() {
    return {type: this.#type}
  }
}
